// Imports ------------------------------------------------------------------->

import { Component } from "../Component";
import { element } from "../CustomElement";

import { i18n } from "../../i18n/I18n";
import { I18nLink } from "../flipp-i18n-link/I18nLink";
import { LoginButton } from "../flipp-login-button/LoginButton";
import { AuthProvider, ToastLevel } from "../../definitions/CommonDefinitions";

@element("flipp-social-icons-container")
export class SocialIconsContainer extends Component<{}, void> {

	render() {
		const signinLegalLinks: {[key: number]: string} = {
			1: "https://corp.flipp.com/legal/terms_of_use/",
			2: "https://corp.flipp.com/legal/privacy/"
		};

		return (
			<div>
				<div class="continue-with">{i18n("continue_with")}</div>
				<div class="social-icon-container">
					<div class="social-icon">
						<LoginButton provider={AuthProvider.GOOGLE} context="signin" round={true} />
					</div>
					<div class="social-icon">
						<LoginButton provider={AuthProvider.FACEBOOK} context="signin" round={true} />
					</div>
				</div>
				<div class="legal">
					<I18nLink key="signin_legal" values={JSON.stringify(signinLegalLinks)} />
				</div>
			</div>
		);
	}
}
